export const getColors = theme => ({
  baseColor: theme.colors['palette-grey-light-200'],
  shimmerColor: theme.colors['palette-grey-light-100'],
  lighterShimmerColor: theme.colors['palette-grey-light-300']
});
export const shimmerRowAnimation = {
  '@keyframes shimmer-row': {
    '100%': {
      width: '200%'
    }
  }
};
export const shimmerAnimation = {
  '@keyframes shimmer': {
    '20%': {
      opacity: 0.3
    },
    '35%': {
      opacity: 0.7
    },
    '45%': {
      opacity: 0.5
    }
  }
};
export const getShimmerStyles = (theme, animation) => {
  const {
    baseColor
  } = getColors(theme);
  return {
    position: 'relative',
    backgroundColor: baseColor,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      ...animation
    }
  };
};